<template>
  <div>
    <header-component></header-component>
    <!-- 正直良くわからないが、 slot を使うと v-data が消える模様 -->
    <main class="requests-layout">
      <slot></slot>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";

export default {
  components: { HeaderComponent, FooterComponent },
  methods: {
    hourToJPTimeStr(hour) {
      // 1.25 から 1時間15分 を出力する、等。
      const hourStr = Math.floor(hour).toString() + "時間";
      // 小数をキーにしたくはない…ので、四捨五入して100をかける。
      const minuteKey = Math.round((hour % 1) * 100).toString();
      const minuteStrObj = {
        "0": "00分",
        "25": "15分",
        "50": "30分",
        "75": "45分"
      };
      const minuteStr = minuteStrObj[minuteKey];
      return hourStr + minuteStr;
    }
  }
};
</script>

<style lang="scss">
// 正直良くわからないが、 slot を使うと v-data が消えるようなので
//（つまり scoped をつけても無意味になるようなので、）
// ここだけはちゃんとクラスで指定しないといけない。
main.requests-layout {
  display: flex;
  padding: 0;
  .br_sp {
    display: none;
  }
  h1 {
    text-align: center;
    font-size: 24px;
  }
  .warning {
    flex: 0 0 auto;
    color: red;
  }
  .card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 575px;
    margin: auto;
    padding: 16px;
    box-sizing: border-box;
    background: #fff;
    text-align: left;
    .input-rows {
      .input-row {
        display: flex;
        margin-top: 20px;
        &.estimate {
          .header {
            color: #00984b;
            font-size: 20px;
          }
          .additional {
            font-size: 14px;
            line-height: 1.2em;
            // word-wrap: wrap;
          }
          .calc {
            margin-top: 16px;
            .item {
              display: flex;
              justify-content: flex-end;
              flex-wrap: nowrap;
              > div{
                flex: 0 0 auto;
              }
              .label {
                flex: 1 1 auto;
              }
              .yen {
                text-align: right;
                min-width: 4em;
                input {
                  width: 6em;
                  text-align: right;
                }
              }
            }
          }
        }
        &.unit-fee {
          // マイページから作成する場合に使用するもの
          .main {
            input {
              width: 4em;
            }
          }
        }
        .header {
          flex: 0 0 25%;
          font-size: 15px;
        }
        .main {
          flex: 1 1 auto;
          margin-left: 8px;
          .img.thumbnail {
            width: 50px;
            height: 50px;
            img {
              display: block;
              width: 100%;
            }
          }
          .stars {
            .star {
              color: red;
              &.interactive {
                cursor: pointer;
              }
            }
          }
          .radio-label:not(:first-of-type) {
            margin-left: 20px;
          }
          textarea {
            width: 100%;
            height: 22.5em;
            padding: 10px;
            box-sizing: border-box;
            line-height: 1.6em;
            border-radius: 8px;
            font-size: 14px;
          }
        }
      }
    }
    .notice {
      .message {
        text-align: center;
        margin-top: 20px;
        color: blue;
      }
    }
    .note {
      margin-top: 30px;
    }
    .paying {
      font-size: 32px;
      text-align: center;
    }
    .buttons {
      display: flex;
      justify-content: space-around;
      margin: 10px 0;
      .button {
        font-size: 16px;
        margin-top: 10px;
        color: white;
        background: #26c6da;
        box-shadow: 0 5px 18px rgba(38, 198, 218, 0.56);
        padding: 16px 24px;
        border-radius: 9999px;
        border: none;
        &:disabled {
          background: darkgray;
          color: lightgray;
          box-shadow: none;
        }
      }
    }
    .start-end-message {
      color: blue;
    }
    .modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      display: flex;
      padding: 16px;
      background: rgba(0, 0, 0, 0.4);
      .card {
        // 出来る限り、画面に収まるようにしないといけない。
        padding-top: 0;
        margin: auto;
        box-sizing: border-box;
        width: 100%;
        max-width: 575px;
        max-height: 100%;
        overflow-y: auto;
        .input-rows {
          .input-row {
            margin-top: 12px;
          }
        }
        .are-you-sure {
          margin-top: 16px;
          text-align: center;
        }
        .buttons {
          margin-top: 0;
          border: none;
        }
      }
    }
  }
  @media (max-width: 575px) {
    h1 {
      text-align: center;
      font-size: 20px;
    }
    .br_pc {
      display: none;
    }
    .br_sp {
      display: inline;
    }
    .card {
      padding: 10px;
      font-size: 14px;
      .input-rows {
        .input-row {
          flex-flow: column;
          max-width: 400px;
          margin-left: auto;
          margin-right: auto;
          .header {
            flex: 0 0 auto;
            font-size: 12px;
            color: gray;
            line-height: 1.4em;
          }
          .main {
            flex: 0 0 auto;
            margin-top: 0;
            margin-left: 0;
            textarea {
              padding: 10px;
            }
          }
          &.estimate {
            position: relative;
            .header {
              font-size: 18px;
            }
            > .main {
              > .header {
                position: absolute;
                top: 0;
                right: 0;
              }
            }
            .calc {
              .item {
                flex-wrap: wrap;
              }
            }
          }
        }
      }
      .modal {
        padding: 10px;
      }
    }
  }
  /* 早朝深夜料金 */
  @media (max-width: 360px) {
    .card {
      .input-rows {
        .input-row {
          &.estimate {
            .calc {
              .item {
                .label {
                  flex: 0 0 100%;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RequestsLayout.vue